export const Currency = ({ currency }) => {
    // Create our number formatter.
    const formatter = new Intl.NumberFormat(undefined, {
        currency: 'USD',
        currencyDisplay: 'narrowSymbol',
        maximumFractionDigits: 2,
        minimumFractionDigits: 2,
        style: 'currency'
    });

    return formatter.format(currency);
};
